export const Action = {
    INCUBATE_56C: "INCUBATE_56C",
    INCUBATE_56C_1H: "INCUBATE_56C_1H",
    INCUBATE_56C_2H: "INCUBATE_56C_2H",
    INCUBATE_56C_ON: "INCUBATE_56C_ON",
    INCUBATE_56C_R: "INCUBATE_56C_R", // This action is a reverse action, so it will run till it is stopped.
    SPIN: "SPIN",
    SHAKE_RT: "SHAKE_RT",
    LYNX_WORKFILE: "LYNX_WORKFILE",
    INCUBATE_65C: "INCUBATE_65C",
    INCUBATE_98C: "INCUBATE_98C",
    INCUBATE_WGA_RT: "INCUBATE_WGA_RT",
    STOP_INCUBATION_WGA_RT: "STOP_INCUBATION_WGA_RT",
    INCUBATE_WGA_37C: "INCUBATE_WGA_37C",
    STOP_INCUBATION_WGA_37C: "STOP_INCUBATION_WGA_37C",
    CENTRIFUGE: "CENTRIFUGE",
    STOP_CENTRIFUGATION: "STOP_CENTRIFUGATION",
    QC_CHECK: "QC_CHECK",
    MAX_DRYING_TIME: "MAX_DRYING_TIME",
    STOP_DRYING: "STOP_DRYING",
    INCUBATE_95C: "INCUBATE_95C",
    STOP_INCUBATE_95C:"STOP_INCUBATE_95C",
    INCUBATE_RT: "INCUBATE_RT",
    RUN_THERMO_CYCLER: "RUN_THERMO_CYCLER",
    INCUBATE_37C: "INCUBATE_37C",
    STOP_INCUBATION_37C: "STOP_INCUBATION_37C",
    INCUBATE_NEG_20C: "INCUBATE_NEG_20C",
    STOP_INCUBATION_NEG_20C: "STOP_INCUBATION_NEG_20C",
    INCUBATION_58C: "INCUBATION_58C",
    STOP_INCUBATION_56C_1H: "STOP_INCUBATION_56C_1H",
    STOP_INCUBATION_56C_2H: "STOP_INCUBATION_56C_2H",
    STOP_INCUBATION_56C_ON: "STOP_INCUBATION_56C_ON",
    STOP_INCUBATION_56C_R: "STOP_INCUBATION_56C_R",
    STOP_INCUBATION_56C: "STOP_INCUBATION_56C",
    STOP_INCUBATION_65C: "STOP_INCUBATION_65C",
    STOP_INCUBATION_98C: "STOP_INCUBATION_98C",
    INCUBATE_48C: "INCUBATE_48C",
    STOP_INCUBATE_48C: "STOP_INCUBATE_48C",
    SHAKING:"SHAKING",
    STOP_SHAKING:"STOP_SHAKING",
    TRANSFER_LYSIS: "TRANSFER_LYSIS",
    PREPARE_OKTOPURE: "PREPARE_OKTOPURE",
    SHAKE_1500_2M: "SHAKE_1500_2M",
    SHAKE_1500_10S: "SHAKE_1500_10S",
    ADD_CHEMICAL_MIX:"ADD_CHEMICAL_MIX",
    NEUTRALIZATION: "NEUTRALIZATION",
    AMPLIFICATION: "AMPLIFICATION",
    FRAGMENTATION_1: "FRAGMENTATION_1",
    FRAGMENTATION_2: "FRAGMENTATION_2",
}

export const BeadChipAction = {
    TRANSFER_TO_CHAMBER: "TRANSFER_TO_CHAMBER",
    IMAGE_BEADCHIP: "IMAGE_BEADCHIP",
    BEADCHIP_DRYING: "BEADCHIP_DRYING",
    GENE_TITAN_WORKFILE: "GENE_TITAN_WORKFILE",
    GENE_TITAN_LOADED: "GENE_TITAN_LOADED",
    INCUBATE_58C:"INCUBATE_58C",
    INCUBATE_48C:"INCUBATE_48C",
    WASH_AND_STAIN_PREP: "WASH_AND_STAIN_PREP",
    STABILIZATION : "STABILIZATION",
    STAIN1 : "STAIN1",
    STAIN2 : "STAIN2",
    LIGATION : "LIGATION",
    HOLD_BUFFER : "HOLD_BUFFER"
}